import { Product } from "../../types/Product";
import { ProductVariant } from "../../types/ProductVariant";
import { formatMoney } from "../../styles/liquidGlass";
import { esSuscripcion } from "@ecommerce/shared-utils";

interface ProductBasicInfoProps {
    product: Product;
    variant?: ProductVariant | null;
}

export default function ProductBasicInfo({ product, variant }: ProductBasicInfoProps) {
    const displayPrice = variant ? variant.precio : product.precio;
    const isSuscripcion = esSuscripcion(product.tinCodProductoFormaComercializacion);

    return (
        <div>
            <h1
                style={{
                    fontSize: 40,
                    lineHeight: 1.05,
                    margin: 0,
                    fontWeight: 700,
                    letterSpacing: "-0.03em",
                    color: "var(--ink-900)",
                }}
            >
                {product.nombre}
            </h1>

            <div
                style={{
                    marginTop: 20,
                    display: "flex",
                    alignItems: "baseline",
                    gap: 12,
                    flexWrap: "wrap",
                }}
            >
                {displayPrice === 0 ? (
                    <span
                        className="mono"
                        style={{
                            fontSize: 22,
                            fontWeight: 600,
                            color: "var(--ink-500)",
                        }}
                    >
                        Consultar precio
                    </span>
                ) : (
                    <>
                        <span
                            className="mono"
                            style={{
                                fontSize: 36,
                                fontWeight: 700,
                                letterSpacing: "-0.025em",
                                color: "#00629c",
                            }}
                        >
                            {formatMoney(displayPrice)}
                        </span>
                        {isSuscripcion && (
                            <span
                                style={{ fontSize: 16, fontWeight: 400, color: "var(--ink-500)" }}
                            >
                                / mes
                            </span>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
